<!--
 * @Author: Alfred huqitaoit@gmail.com
 * @Date: 2021-12-20 11:08:35
 * @LastEditors: Alfred
 * @LastEditTime: 2023-11-16 11:05:26
 * @Description: 
 * @FilePath: \src\views\system\EducationalSetting.vue
-->
<template>
  <div class="educational-setting">
    <div class="tuolele-main-box">
      <div class="setting-title">复课设置</div>
      <el-form ref="form" :model="dataInfo" label-width="180px">
        <!-- <el-form-item label="复课是否需要绑定微信">
          <el-radio-group
            v-model="dataInfo.BANDING_WECHAT"
            @change="changeStauts('BANDING_WECHAT')"
          >
            <el-radio label="1">需绑定</el-radio>
            <el-radio label="0">无需绑定</el-radio>
          </el-radio-group>
          <p>(设置复课需绑定微信后，未绑定微信公众号的学员无法复课)</p>
        </el-form-item> -->
        <el-form-item label="复课校长审核">
          <el-radio-group
            v-model="dataInfo.LAST_AUDIT"
            @change="changeStauts('LAST_AUDIT')"
          >
            <el-radio label="1">需校长审核</el-radio>
            <el-radio label="0">无需校长审核</el-radio>
          </el-radio-group>
          <p>
            (设置复课需校长审核后，停课小于3个工作日的学员，校长审核通过后，学员才能复课成功)
          </p>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EducationalSetting',
  components: {},
  data() {
    return {
      dataInfo: {}
    }
  },
  computed: {},
  watch: {},
  mounted() {
    this.getVasList()
  },
  methods: {
    async getVasList() {
      const ret = await this.$http.getVasList()
      if (ret.code == 200) {
        this.dataInfo = ret.data.company_switch
      }
    },
    async changeStauts(key) {
      const ret = await this.$http.setVasSubmit({
        key,
        value: this.dataInfo[key]
      })
      if (ret.code == 200) {
        this.getVasList()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.educational-setting {
  .setting-title {
    font-size: 20px;
    color: $color_black;
    margin-bottom: 30px;
  }
  ::v-deep .el-form {
    .el-radio {
      width: 130px;
      &.is-checked {
        .el-radio__inner {
          border-color: $color_blue;
          color: $color_blue;
          background: $color_blue;
        }
        .el-radio__label {
          color: $color_blue;
        }
      }
    }
  }
}
</style>
